export default "__VITE_ASSET__BpsgCeZx__"